import { useNavigate } from 'react-router-dom';

import { ComponentTypeForm } from '../components/ComponentTypeForm';

export const EditComponentTypesComponentTypePage = () => {
  const navigate = useNavigate();

  return (
    <div className="p-10">
      <div>
        <ComponentTypeForm
          type="Edit"
          onSubmit={async (componentTypeId) => {
            navigate(`/component-types`);
          }}
          onCancel={() => {
            navigate(`/component-types`);
          }}
        />
      </div>
    </div>
  );
};
